<template>
  <PageWrapper :active-page="PAGE_ONBOARDING_APPLY" :active-section="SECTION_ONBOARDING">
    <iRow align="center">
      <iColumn width="hug" align="left">
        <iHeader>Apply to join the Inspiration Creator Community</iHeader>
        <iDivider />
        <iSpace />

        <iSubHeading>Connect Your Social Media Accounts</iSubHeading>
        <iParagraph>When connecting your social media accounts, your chances of approval are significantly higher!</iParagraph>
        <iLink :href="`/settings/org/${orgId}/social-networks`">
          <iButton
            icon-left="tabler:social"
            variant="primary"
            text-display="inline-flex"
            content-wrap="nowrap"
          >
            Add Social Media
          </iButton>
        </iLink>
        <iSpace />
        <iDivider />
        <iSpace />

        <iSubHeading>What excites you about Inspiration?</iSubHeading>
        <iTextArea v-model="excitementText" placeholder="Tell us why you're excited to join Inspiration as a creator..." @change="handleInputChange('excitementText')" />
        <iText v-if="!isFormValid && formErrors['excitementText']" variant="error">
          {{ formErrors["excitementText"] }}
        </iText>
        <iSpace />

        <iSubHeading>Who are you?</iSubHeading>
        <iSelect
          v-model="areaOfInterest"
          return-value
          value-field="value"
          :items="whoAreYouOptions"
          @update:model-value="handleInputChange('areaOfInterest')
          "
        />
        <iText v-if="!isFormValid && formErrors['areaOfInterest']" variant="error">
          {{ formErrors["areaOfInterest"] }}
        </iText>
        <iSpace />

        <iCheckbox v-model="termsAndConditionsAccepted" @change="handleInputChange('termsAndConditionsAccepted')">
          <iRow vertical-align="middle" gap="extraSmall">
            I have read and agree to the <iLink href="">
              Terms and Conditions
            </iLink>
          </iRow>
        </iCheckbox>
        <iText v-if="!isFormValid && formErrors['termsAndConditionsAccepted']" variant="error">
          {{ formErrors["termsAndConditionsAccepted"] }}
        </iText>
        <iSpace />

        <iButton
          icon-left="iconoir:submit-document"
          variant="primary"
          type="submit"
          text-display="inline-flex"
          content-wrap="nowrap"
          loading-spinner-position="after"
          :is-loading="isLoading"
          :disabled="!isFormValid || isLoading"
          @click="submitApplication"
        >
          Apply
        </iButton>
      </iColumn>
    </iRow>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { SECTION_ONBOARDING, PAGE_ONBOARDING_APPLY } from "@/constants/nav-constants";
import { mapActions, mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";
import { WHO_ARE_YOU_OPTIONS } from "@/constants/onboarding-application-constants";

export default {
  name: "CreatorApply",
  components: { PageWrapper },
  data() {
    return {
      termsAndConditionsAccepted: false,
      excitementText: "",
      areaOfInterest: "",
      // TODO: handle social media - need to possibly rework social media into component
      formErrors: {},
      SECTION_ONBOARDING,
      PAGE_ONBOARDING_APPLY,
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["isLoading", "orgId"]),
    whoAreYouOptions() {
      return WHO_ARE_YOU_OPTIONS;
    },
    isFormValid() {
      return Object.keys(this.formErrors).length === 0;
    },
  },
  methods: {
    ...mapActions(useGeneralStore, ["saveOnboardingApplication", "setIsLoading"]),
    handleInputChange(key) {
      if (this.formErrors[key]) {
        this.runValidation();
      }
    },
    runValidation() {
      this.formErrors = {};

      if (!this.excitementText || !this.excitementText.trim()) {
        this.formErrors.excitementText = "Tell us why you're excited to join our platform";
      }

      if (!this.areaOfInterest) {
        this.formErrors.areaOfInterest = "Please select who you are";
      }

      if (!this.termsAndConditionsAccepted) {
        this.formErrors.termsAndConditionsAccepted = "Please accept our terms and conditions in order to proceed";
      }
    },
    submitApplication() {
      this.runValidation();
      if (!this.isFormValid) {
        return;
      }

      this.setIsLoading(true);
      this.saveOnboardingApplication(this.termsAndConditionsAccepted, this.excitementText, this.areaOfInterest, () => {
        window.location = "apply";
      });
    },
  },
};
</script>
